type WindowConfig = Window & { env: { COGNITO_HOSTED_UI_URL: string; COGNITO_OAUTH_CLIENT_ID: string; } }

export function handleGitHubSignIn() {
    const cogntioUrl = (window as unknown as WindowConfig).env.COGNITO_HOSTED_UI_URL;
    const client_id = (window as unknown as WindowConfig).env.COGNITO_OAUTH_CLIENT_ID;
    window.open(cogntioUrl + `/oauth2/authorize?identity_provider=GitHub&response_type=CODE&client_id=${client_id}&scope=aws.cognito.signin.user.admin email openid phone profile&state=redirect:portal`, "_self");
}